module.exports = __webpack_public_path__ + "static/undraw_news_go0e-98b0ba4baf12f26f04743344a84c1167.svg";